<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <CCardHeader
              class="d-flex justify-content-between align-items-center"
          >
            اطلاعات نظرسنجی
          </CCardHeader>

          <CCardBody
              class="
              d-flex
              flex-column
              justify-content-center
              align-items-start
              h-100
              w-100
            "
          >
            <div class="poll-spec mb-3">
              <div class="poll-spec__title bold">عنوان:</div>
              {{ poll.title }}
            </div>
            <div class="poll-spec mb-3">
              <div class="poll-spec__title bold">از تاریخ:</div>
              {{ startDate }}
            </div>
            <div class="poll-spec mb-3">
              <div class="poll-spec__title bold">تا تاریخ:</div>
              {{ endDate }}
            </div>
            <div class="poll-spec mb-3">
              <div class="poll-spec__title bold">توضیحات:</div>
              <div class="break-word">{{ poll.text }}</div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol v-if="!poll.finished">
        <CCard>
          <CCardHeader
              class="w-100 d-flex justify-content-between align-items-center"
          >
            سؤالات
            <router-link :to="`/manager/poll/${poll.id}/addQuestion`">
              <CButton class="px-5" color="primary" size="sm" square>
                <CIcon name="cil-plus"/>
                افزودن
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
                :fields="pollQuestionFields"
                :items="pollQuestions"
                :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
                border
                class="w-100 d-flex justify-content-between h-100"
                fixed
                hover
                small
                striped
            >
              <template #text="{ item }">
                <td>
                  <div v-if="item.text.length > 30">
                    {{ item.text.slice(0, 30) }}...
                  </div>
                  <div v-else>{{ item.text }}</div>
                </td>
              </template>
              <template #showQuestion="{ item }">
                <td>
                  <CButton
                      class="modal-button"
                      size="md"
                      square
                      @click="onViewPollQuestionModal(item)"
                  >
                    مشاهده
                  </CButton>
                </td>
              </template>
              <template #editQuestion="{ item }">
                <td>
                  <router-link :to="`/manager/poll/${poll.id}/${item.id}`">
                    <CButton size="md" square>
                      <CIcon name="cil-pen"/>
                    </CButton>
                  </router-link>
                </td>
              </template>
              <template #removeQuestion="{ item }">
                <td>
                  <CButton
                      size="md"
                      square
                      @click="onRemovePollQuestionModal(item)"
                  >
                    <CIcon name="cil-trash"/>
                  </CButton>
                </td>
              </template>
            </CDataTable>
            <RemovePollQuestionModal
                v-model="removePollQuestionModal"
                :question="selectedItem"
                @get-question="getPollQuestions"
            />
            <ViewPollQuestionModal
                v-model="viewPollQuestionModal"
                :question="selectedItem"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow v-if="poll.finished">
      <CCol sm="12">
        <CCard>
          <CCardHeader> نتیجه‌ی نظرسنجی</CCardHeader>
          <CCardBody
              class="
              d-flex
              flex-column
              justify-content-center
              align-items-start
              h-100
            "
          >
            <PollResults
                v-for="question in pollQuestions"
                :key="question.id"
                :question="question"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import RemovePollQuestionModal from "@/components/Modals/Poll/RemovePollQuestionModal";
import ViewPollQuestionModal from "@/components/Modals/Poll/ViewPollQuestionModal";
import PollResults from "@/components/Poll/PollResults";

export default {
  components: {
    PollResults,
    ViewPollQuestionModal,
    RemovePollQuestionModal,
  },
  name: "pollDetails",
  data() {
    return {
      pollQuestionFields: [
        {key: "text", label: "عنوان سؤال"},
        {key: "showQuestion", label: "مشاهده"},
        {key: "editQuestion", label: "ویرایش"},
        {key: "removeQuestion", label: "حذف"},
      ],
      selectedItem: {},
      poll: {},
      loading: false,
      pollQuestions: [],
      removePollQuestionModal: false,
      viewPollQuestionModal: false,
    };
  },
  computed: {
    startDate() {
      return this.poll.startDate.replaceAll("-", "/");
    },
    endDate() {
      return this.poll.endDate.replaceAll("-", "/");
    },
  },
  mounted() {
    this.getPoll();
    this.getPollQuestions();
  },
  methods: {
    async getPoll(routeName) {
      try {
        this.loading = true;
        const {id: pollId} = this.$route.params;
        const {data} = await axios.get(`/survey/${pollId}`);
        this.poll = data;
        routeName = `${data.title}`;
        this.$emit("go-to", routeName);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getPollQuestions() {
      try {
        this.loading = true;
        const {id: surveyId} = this.$route.params;
        const {data} = await axios.get(`/survey/${surveyId}/question`);
        this.pollQuestions = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onRemovePollQuestionModal(item) {
      this.selectedItem = item;
      this.removePollQuestionModal = true;
    },
    onViewPollQuestionModal(item) {
      this.selectedItem = item;
      this.viewPollQuestionModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: calc(100% - 24px);
}

.poll-spec {
  display: flex;
  width: 100%;

  &__title {
    min-width: 100px;
  }
}

.break-word {
  width: calc(100% - 100px);
}
</style>